import React, { useState, useEffect } from 'react';
import '../styles/Home.css';

const Home: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    '/images/hero/Whisk_34b86f3ea49d92e84634b5c0d06bda96eg.png',
    '/images/hero/Whisk_64b1f253df61c26aadc470358e3f060fdr.png',
    '/images/hero/Whisk_861ef2a255dbeeebc5c4515bbfb093b4dr.png',
    '/images/hero/Whisk_ejn5idm1ymmyctz50czkjtotezywqtlmn2mw0iz.png'
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div className="home-container">
      <div className="slider-wrapper">
        <div className="slider">
          {slides.map((slide, index) => (
            <img
              key={index}
              src={slide}
              alt={`Slide ${index + 1}`}
              className={`slide ${index === currentSlide ? 'active' : ''}`}
            />
          ))}
        </div>
        <div className="slider-dots">
          {slides.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => setCurrentSlide(index)}
            />
          ))}
        </div>
      </div>

      <div className="home-content">
        <section className="about-section">
          <h2>Welcome to Flyingking Saddlery</h2>
          <p>
            We have been in the horse industry for over fifteen years manufacturing
            bits, spurs, stirrups, hardware, grooming products and blankets. We are
            also developing the products for Marine. Our mission is to provide you
            with quality products at competitive prices.
          </p>
        </section>

        <section className="features-section">
          <div className="feature-card">
            <h3>Quality Products</h3>
            <p>Premium quality horse equipment manufactured with care</p>
          </div>
          <div className="feature-card">
            <h3>Competitive Prices</h3>
            <p>Best prices in the industry without compromising quality</p>
          </div>
          <div className="feature-card">
            <h3>15+ Years Experience</h3>
            <p>Trusted by horse enthusiasts worldwide</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Home;
